var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { boundMethod } from 'autobind-decorator';
import { Component } from 'react';
import { connect } from 'react-redux';
import { dixaWidgetLoader, dixaWidgetSetUser } from './utils/widget';
import { widgetActions } from './widget.actions';
class WidgetComponent extends Component {
    componentDidMount() {
        var _a;
        const { profile } = this.props;
        dixaWidgetLoader(); // Loads Dixa support widget.
        dixaWidgetSetUser(profile); // Sign-in the to the widget.
        (_a = window._dixa) === null || _a === void 0 ? void 0 : _a.call(window, 'api.subscribe', 'onWidgetPresenceChanged', this.handleWidgetPresenceChange);
    }
    componentWillUnmount() {
        var _a;
        (_a = window._dixa) === null || _a === void 0 ? void 0 : _a.call(window, 'api.unsubscribe', 'onWidgetPresenceChanged');
    }
    handleWidgetPresenceChange(presence) {
        this.props.setPresence(presence);
    }
    render() {
        return null;
    }
}
__decorate([
    boundMethod
], WidgetComponent.prototype, "handleWidgetPresenceChange", null);
const mapStateToProps = (state) => {
    return {
        profile: state.settings.profile.profile,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        setPresence(presence) {
            dispatch(widgetActions.setPresence({ presence }));
        },
    };
};
export const Widget = connect(mapStateToProps, mapDispatchToProps)(WidgetComponent);
